export const ROOM_TYPE_WEB_SCHEDULER = 1;
export const ROOM_TYPE_ENTRY_ROOM = 2;
export const ROOM_TYPE_EXIT_ROOM = 3;
export const ROOM_TYPE_OTHER = 99;

// Virtual ID for the Completed appointments column (negative to avoid conflicts)
export const VIRTUAL_UPCOMING_APPOINTMENTS_ROOM_ID = -1;
export const VIRTUAL_COMPLETED_APPOINTMENTS_ROOM_ID = -2;
export const VIRTUAL_ENTRY_ROOM_ID = -3;
export const VIRTUAL_EXIT_ROOM_ID = -4;
export const VIRTUAL_PLACEHOLDER_ROOM_ID = -5;
